import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrLink from 'client/components/SrLink/SrLink';
import SrText from 'client/components/SrText';

const SrPartnerActionButton = ({
  to,
  onClick,
  label,
  iconUrl,
  iconSize,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const ContainerComponent = (to
    ? SrLink
    : SrBox
  );

  return (
    <ContainerComponent
      to={to}
      onClick={onClick}
    >
      <SrBox cursor='pointer' className='SrPartnerActionButton'>
        <SrBox
          borderRadius='14px'
          backgroundColor='rgba(216, 216, 216, 0.3)'
          backgroundImage={`url(${iconUrl})`}
          backgroundSize={iconSize || '22px'}
          backgroundPosition='center'
          backgroundRepeat='no-repeat'
          width='56px'
          height='56px'
          margin={isSmallScreen ? '23px auto 8px auto' : '16px auto 8px auto'}
        />
        <SrText
          font='greycliff'
          weight='800'
          fontSize='13px'
          lineHeight='15.6px'
          align='center'
          display='block'
          color='blue300'
          letterSpacing='0px'
        >
          {label}
        </SrText>
      </SrBox>
    </ContainerComponent>
  );
};

SrPartnerActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

SrPartnerActionButton.displayName = 'SrPartnerActionButton';

export default SrPartnerActionButton;
